// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant'
import util from './libs/utils'
import api from './libs/api'

import 'vant/lib/index.css'
import './assets/scss/main.scss'
// 引入阿里图标
import './assets/iconfont/iconfont.css'
// 过滤器
import filters from './filters/index'
// vuex
import store from './store'
// echarts
import echarts from 'echarts'

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.prototype.util = util
Vue.prototype.api = api

Vue.prototype.$echarts = echarts

Vue.use(Vant)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js